import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import api from '@/api';
import { useCurrentUser } from '~/hooks/useCurrentUser';

export const Route = createFileRoute('/_app/_course/quizzes/$quizSlug')({
  component: QuizSlugRedirect,
});

function QuizSlugRedirect() {
  const { quizSlug } = Route.useParams();
  const { me } = useCurrentUser();
  const navigate = useNavigate();
  const language = me?.language ?? 'EN';

  const { data: resolved } = api.quizBySlug.useQuery({
    path: { slug: quizSlug },
    query: { language },
  });

  useEffect(() => {
    if (!resolved) return;
    // A topic quiz is rendered INLINE on its topic page (legacy's
    // `modules/series/src/Topic.php:34-51` echoes `[LDAdvQuiz]` on
    // `learndash-topic-after`), so a topic-scoped quiz URL belongs there.
    // Routing every quiz slug to the lesson's final quiz sent 1,157 of 1,630
    // `quiz_ids` rows — 71% of legacy quiz URLs — to the wrong screen.
    if (resolved.topic_slug) {
      navigate({
        to: '/topic/$topicSlug/',
        params: { topicSlug: resolved.topic_slug },
        replace: true,
      });
      return;
    }
    navigate({
      to: '/lessons/$lessonSlug/quiz/',
      params: { lessonSlug: resolved.lesson_slug },
      replace: true,
    });
  }, [resolved, navigate]);

  return null;
}
